import React, { useState } from 'react';
import axios from 'axios';
import { getApiUrl, getMediaUrl } from '../utils/site';

export default function ImageGenerator({ onGenerated }) {
  const [prompt, setPrompt] = useState('');
  const [image, setImage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    setLoading(true);
    setImage('');
    try {
      const res = await axios.post(getApiUrl('/api/generate'), { prompt });
      setImage(getMediaUrl(res.data.image_url));
      if (onGenerated) onGenerated();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to generate image');
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 500, margin: '2rem auto', textAlign: 'center' }}>
      <input
        type="text"
        value={prompt}
        onChange={e => setPrompt(e.target.value)}
        placeholder="Describe your jewelry (e.g. gold ring with emerald gemstone)"
        style={{ width: '80%', padding: 10, borderRadius: 8, border: '1px solid #ccc' }}
      />
      <button onClick={handleGenerate} disabled={loading || !prompt} style={{ marginLeft: 10, padding: '10px 20px', borderRadius: 8 }}>
        {loading ? 'Generating...' : 'Generate'}
      </button>
      {image && <img src={image} alt="Generated" style={{ marginTop: 20, maxWidth: '100%', borderRadius: 16, boxShadow: '0 2px 12px #ffd70033' }} />}
    </div>
  );
}
